<template>
  <el-container type="flex" class="main_container">
    <base-header>
      <el-radio-group v-model="status" size="mini" @change="changeList" :disabled="loading">
        <el-radio-button label="0">提现中</el-radio-button>
        <el-radio-button label="1">提现成功</el-radio-button>
      </el-radio-group>
    </base-header>
    <el-main>
      <el-table :data="checkList" height="100%" @selection-change="selected" v-show="!loading" :key="loading">
        <el-table-column
          prop="client_id"
          label="clientId"
          align="left"
          width="120"
        >
        </el-table-column>
        <el-table-column label="提现人信息" width="140">
          <template v-slot="scope">
            <div>
              <img
                :src=scope.row.avatar_url
                alt=""
                style="width: 30px; height: 30px"
              >
              {{scope.row.nickname}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="提现方式" width="90" align="center">
          <template v-slot="scope">
            <el-tag v-show="!scope.row.remit_type" type="success" effect="dark">微信零钱</el-tag>
            <el-tag v-show="scope.row.remit_type === 1" type="warning" effect="dark">银行卡</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in tableColumn"
          :key="item.index"
          :prop="item.prop"
          :label="item.label"
          :align="item.align"
          :width="item.width"
        >
        </el-table-column>
        <el-table-column prop="pass_time" label="审核通过时间" align="center" v-if="status"></el-table-column>
        <el-table-column prop="update_time" label="到账时间" align="center" v-if="status"></el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template v-slot="scope">
            <el-tag v-if="!scope.row.status" color="white">未审核</el-tag>
            <el-tag v-if="scope.row.status === 3" color="#46a0fc" style="color: white">已通过</el-tag>
            <el-tag v-if="scope.row.status === 1" type="success">已到账</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          type="selection"
          width="55"
          :selectable="isPassed">
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
      <div v-show="!this.status">
      总提现金额： {{totalAmount}}元&emsp;&emsp;
      已选提现总额：{{sum}}元&emsp;&emsp;
      <el-button @click="submit" type="primary" size="mini">通过</el-button>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import pageMixin from '../../../mixins/page'

export default {
  name: 'PayCheck',
  mixins: [pageMixin],
  data () {
    return {
      PayCheckURL: this.getDomain() + 'bmsummary/get_withdraw_log_list', // 提现审核
      WithdrawURL: this.getDomain() + 'bmsummary/withdraw', // 同意提现
      checkList: [],
      totalAmount: 0,
      sum: 0,
      status: 0,
      selectRow: [],
      loading: true,
      tableColumn: [
        {
          prop: 'phone',
          label: '手机号码',
          align: 'center'
        },
        {
          prop: 'amount',
          label: '提现金额(元)',
          align: 'center'
        },
        {
          prop: 'balance',
          label: '提现后余额(元)',
          align: 'center'
        },
        {
          prop: 'create_time',
          label: '申请提现时间',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    getList () {
      this.loading = true
      let params = {
        page: this.page,
        pagesize: this.pagesize,
        status: this.status
      }
      let handle = res => {
        this.checkList = res.data.content.withdraw_log_list
        this.totalCount = res.data.content.total_count
        this.totalAmount = res.data.content.total_amount
        this.totalAmount = this.totalAmount / 100
        this.checkList.forEach(item => {
          item.amount = item.amount / 100
          item.balance = item.balance / 100
          item.create_time = this.timeTransform(item.create_time)
          item.update_time = this.timeTransform(item.update_time)
          item.pass_time = item.pass_time ? this.timeTransform(item.pass_time) : ''
        })
      }
      let loadings = () => {
        this.loading = false
      }
      this.__axios(this.PayCheckURL, params, handle, loadings)
    },
    // 判断是否已审核
    isPassed (row) {
      return !row.status
    },
    // 打勾的处理
    selected (selection) {
      this.sum = 0
      this.selectRow = []
      selection.forEach(item => {
        this.sum += item.amount
        this.selectRow.push(item.t_withdraw_log_id)
      })
    },
    // 提交选择
    submit () {
      if (!this.selectRow[0]) {
        this.$message.warning('未选择任何提现项')
      } else {
        this.__confirm('确定通过?', this.__axios, [this.WithdrawURL, {t_withdraw_id_list: this.selectRow}, this.getList])
      }
    },
    // 切换正在审核、已审核
    changeList () {
      this.loading = true
      this.page = 1
      this.pagesize = 50
      this.status = parseInt(this.status)
      this.getList()
    }
  },
  mounted () {
    this.getList()
  }
}
</script>

<style scoped>
.footer {
  justify-content: space-between;
}
</style>
